export const PROVIDER_INFO_REQUESTED = "PROVIDER_INFO_REQUESTED";
export const PROVIDER_INFO_SUCCESS = "PROVIDER_INFO_SUCCESS";
export const PROVIDER_INFO_FAILED = "PROVIDER_INFO_FAILED";
export const REFRESH_PROVIDER_INFO = "REFRESH_PROVIDER_INFO";

export function dispatchProviderInfo(payload){
    return { type: PROVIDER_INFO_REQUESTED, payload };
}
